import React from 'react';
import './StillNeedHelp.scss';

const { PHRASE_TRANSLATIONS } = process.env.REACT_APP_MARKET_VALUES;

const StillNeedHelp = () => {
    // exceptional validation for markets who removes those values from Phrase, as Spain market
    const existValues =
        PHRASE_TRANSLATIONS.stillNeedHelpTitle && PHRASE_TRANSLATIONS.stillNeedHelpBody;
    if (existValues)
        return (
            <div className="section">
                <h2 className="section__title" data-testid="snh-title">
                    {PHRASE_TRANSLATIONS.stillNeedHelpTitle}
                </h2>
                <div className="section__body" data-testid="snh-body">
                    {PHRASE_TRANSLATIONS.stillNeedHelpBody}
                </div>
            </div>
        );
    return null;
};

export default StillNeedHelp;
